import { FEATURE_FLAGS } from 'constants/tracking'

// Map from flag key → readable camelCase name from our constants
export const FLAG_LABEL: Record<string, string> = Object.fromEntries(Object.entries(FEATURE_FLAGS).map(([label, key]) => [key, label]))
